import { Button, Modal } from '@indipia/ui-core'
import { useScheduleRequestCount } from '../hooks/useScheduleRequestCount'
import { buildScheduleReplaceNotice } from '../constants/scheduleReplaceNotice.logic'

/** 이미 스케줄이 있는 현장 — 기존 스케줄 교체 확인(공종 선택·배정 확인 화면 공용) */
export function ScheduleReplaceModal({ open, onCancel, onConfirm, existingScheduleId }: { open: boolean; onCancel: () => void; onConfirm: () => void; existingScheduleId?: number | null }) {
  const requestCount = useScheduleRequestCount(open ? existingScheduleId : null)
  const notice = buildScheduleReplaceNotice({ mode: 'replace', requestCount })
  return (
    <Modal
      open={open}
      onClose={onCancel}
      footer={<>
        <Button variant="secondary" onClick={onCancel}>취소</Button>
        <Button
          variant="primary"
          onClick={onConfirm}
        >교체하고 생성</Button>
      </>}
    >
      <div style={{ margin: 'calc(-1 * var(--spacing-05)) calc(-1 * var(--spacing-05)) 0', background: 'color-mix(in srgb, var(--color-warning) 10%, white)', padding: '22px 24px 16px', borderBottom: '1px solid color-mix(in srgb, var(--color-warning) 25%, white)', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'var(--color-warning)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--shell-surface)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L14.71 3.86a2 2 0 0 0-3.42 0z"/>
          </svg>
        </div>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--color-warning)', marginBottom: 4 }}>이미 스케줄이 있는 현장입니다</div>
          <div style={{ fontSize: 'var(--type-caption-size)', color: 'var(--color-warning)', lineHeight: 1.6 }}>
            선택한 현장에는 이미 진행 중인 스케줄이 있습니다.<br />계속 진행하면 기존 스케줄은 삭제되고 새 스케줄로 교체됩니다.
            {notice && <><br />{notice}</>}
          </div>
        </div>
      </div>
    </Modal>
  )
}
